
<div class="change-password-dialog">

  <form
    [formGroup]="formGroup"
    class="password-form"
    (ngSubmit)="close()"
  >

    <!-- Password attuale -->
    <div class="password-field">
      <label for="old-password">
        Password attuale
        <span class="required-marker">*</span>
      </label>

      <p-password
        inputId="old-password"
        formControlName="oldPassword"
        [(ngModel)]="changePassword.oldPassword"
        [feedback]="false"
        [toggleMask]="true"
        [inputStyle]="{ width: '100%' }"
        styleClass="password-input"
        placeholder="Inserisci la password attuale"
      ></p-password>
    </div>

    <!-- Nuova password -->
    <div class="password-field">
      <label for="new-password">
        Nuova password
        <span class="required-marker">*</span>
      </label>

      <p-password
        inputId="new-password"
        formControlName="newPassword"
        [(ngModel)]="changePassword.newPassword"
        [feedback]="false"
        [toggleMask]="true"
        [inputStyle]="{ width: '100%' }"
        styleClass="password-input"
        placeholder="Inserisci la nuova password"
      ></p-password>
    </div>

    <!-- Conferma nuova password -->
    <div class="password-field">
      <label for="confirm-password">
        Conferma nuova password
        <span class="required-marker">*</span>
      </label>

      <p-password
        inputId="confirm-password"
        formControlName="confirmPassword"
        [(ngModel)]="confirmPassword"
        [feedback]="false"
        [toggleMask]="true"
        [inputStyle]="{ width: '100%' }"
        styleClass="password-input"
        placeholder="Ripeti la nuova password"
      ></p-password>
    </div>

    <!-- Requisiti -->
    <div class="password-requirements">
      <div class="requirements-icon">
        <i class="pi pi-info-circle"></i>
      </div>

      <div class="requirements-content">
        <h4>Requisiti della password</h4>
        <p>
          La password deve contenere da 8 a 32 caratteri,
          almeno una lettera maiuscola, una minuscola,
          un numero e un carattere speciale.
        </p>
      </div>
    </div>

    <!-- Errori di validazione -->
    <div
      class="password-error"
      *ngIf="
        formGroup.invalid &&
        (formGroup.dirty || formGroup.touched) &&
        errors
      "
      role="alert"
    >
      <i class="pi pi-exclamation-circle"></i>
      <span>{{ errors }}</span>
    </div>

    <!-- Conferma -->
    <div class="password-actions">
      <button
        pButton
        type="submit"
        label="Conferma modifica"
        icon="pi pi-check"
        class="confirm-button"
        [disabled]="!formGroup.valid"
      ></button>
    </div>

  </form>
</div>
